var tabsGroup = tabsGroup || {};

tabsGroup = {
    tabSelected: '',

    init: function ()
    {
        this.loadCommunitiesCarousel();
    },

    selectTab: function ()
    {
        console.log('select tab');
        $select = $(this).parent();
        $item = $(this);
        $parent = $('.js-tabContainer');

        let tabIDName = $item.data('tab-id-name');
        let tabContentNew = $parent.find('.js-tabContent[data-tab-id-content="'+tabIDName+'"]');
        let tabNameList = $parent.find('.js-tabItem');
        let tabContentList = $parent.find('.js-tabContent');
        tabsGroup.tabSelected = tabIDName;

        // Unselect old tab
        $(tabNameList).removeClass('isSelected');
        $(tabContentList).removeClass('isSelected');

        // Select new tab
        $item.addClass('isSelected');
        $(tabContentNew).addClass('isSelected');

        if ($(window).width() <= 993) {
            $('html, body').animate({
                scrollTop: $item.offset().top - 20 
            }, 400);
        }

        tabsGroup.loadCommunitiesCarousel();
    },

    toggleTabContent: function() {
        let $elem = $(this).parent().find('.tab-content-hidden-mobile');

        $elem.hasClass('show') ? $elem.removeClass('show') : $elem.addClass('show');
        $(this).hasClass('show') ? $(this).removeClass('show') : $(this).addClass('show')
    },

    loadCommunitiesCarousel: function () {
        let $tab = $('.js-tabContent.isSelected')
        let $communitiesCarousel = $tab.find(".js-communitiesCarousel");

        if ($communitiesCarousel.length === 0) return;
            $communitiesCarousel.on("init", function () {
            $communitiesCarousel.addClass("isLoaded");
        });

        $communitiesCarousel.slick({
        arrows: true,
        dots: false,
        infinite: false,
        speed: 400,
        slidesToShow: 2.25,
        slidesToScroll: 1,
        appendArrows: ".js-communitiesArrows",
        responsive: [
            {
            breakpoint: 1200,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
            },
            {
            breakpoint: 940,
            settings: {
                slidesToShow: 1.5,
                slidesToScroll: 1
            }
            },
            {
            breakpoint: 768,
            settings: {
                slidesToShow: 1.2,
                slidesToScroll: 1
            }
            }
        ]
        });
    },

    binds: function ()
    {
        $('.js-tabItem').on('click', this.selectTab);

        if ($(window).width() > 993) {
            $('.js-openTabContent').on('click', this.toggleTabContent);
        }
    }
};

$(document).ready(function () {
    console.log('tabsGroup');
    tabsGroup.binds();
    tabsGroup.init();
});